import { IconCode } from '@components/icons/icon-code';
import { InfoButton, Sidebar } from '@components/sidebar';
import { showError } from '@components/toaster';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import {
  ActionFooter,
  ActionHeader,
  ActionSidebarLoading,
  createActionForm,
  SidebarProps,
  useCreateActionFormStore,
} from 'ui/journey-builder/node-types/common';

import { ActionType, CodeData, CodeFormFields, formatFormData, Info } from './common';

import { FormWithUnsavedChangesPrompt } from '../../journey-builder/unsaved-changes-prompt';

const Form = createActionForm<CodeData>();

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { t } = useScopedTranslate(sidebarLocale);
  const formStore = useCreateActionFormStore();
  const isDirty = formStore.useIsDirty();

  const { data, isLoading } = useJourneyAction<ActionType>(journeyActionId);

  const editMutation = useUpdateJourneyAction(journeyActionId, {
    onError: (data) => {
      if (data.response.data.values.code) {
        showError(t('codeRequired'));
      }
    },
  });
  const handleSave = (data: CodeData) => {
    return editMutation.mutateAsync(formatFormData(data));
  };

  if (isLoading || !data) {
    return (
      <ActionSidebarLoading title={t('code')} icon={IconCode} iconColor="indigo100" {...props} />
    );
  }
  return (
    <Sidebar>
      <ActionHeader title={t('code')} icon={IconCode} iconColor="indigo100" {...props}>
        <InfoButton>
          <Info />
        </InfoButton>
      </ActionHeader>
      <Sidebar.Content>
        <FormWithUnsavedChangesPrompt store={formStore} onSubmit={handleSave}>
          <CodeFormFields Form={Form} data={data} />
          <Sidebar.Separator />
          <ActionFooter action={data} isDisabled={!isDirty || editMutation.isLoading} form={Form} />
        </FormWithUnsavedChangesPrompt>
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    code: 'Code',
    codeRequired: 'Missing code or syntax error, please check the code editor',
  },
};
